import React, { useCallback, useRef } from 'react'

const MultiSelectItem = ({ value, children }) => {
  const input = useRef()

  const handleChange = useCallback((e) => {
    const event = new CustomEvent('MultiSelectEvent', {
      bubbles: true,
      cancelable: true,
      detail: {
        value: e.target.value,
        checked: e.target.checked
      }
    })
    input.current.dispatchEvent(event)
  }, [])

  return (
    <div className='multi-select-item'>
      <input
        ref={input}
        onChange={handleChange}
        type='checkbox'
        value={value}
      />
      {children}
    </div>
  )
}

export default MultiSelectItem
